import { render, staticRenderFns } from "./recommendRfq.vue?vue&type=template&id=e48a0fd8&scoped=true"
import script from "./recommendRfq.vue?vue&type=script&lang=js"
export * from "./recommendRfq.vue?vue&type=script&lang=js"
import style0 from "./recommendRfq.vue?vue&type=style&index=0&id=e48a0fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a0fd8",
  null
  
)

export default component.exports